import React from 'react';
import { Link2Icon } from 'lucide-react';

import { useGuestSideSheetContext } from '../guestSideSheetContext';

export const GuestSideSheetCommunitiesSection = (): React.ReactNode => {
  const {
    guestData: { guest }
  } = useGuestSideSheetContext();
  const communities = guest.associatedCommunities;
  if (!communities || communities.length < 1) return null;
  const isMultipleCommunities = communities.length > 1;
  return (
    <div className="tw-flex tw-max-w-[95%] tw-flex-row tw-items-center">
      <Link2Icon size={16} />
      <p className="tw-m-0 tw-ml-2  tw-font-medium tw-text-dark-black">
        Linked to {isMultipleCommunities ? 'communities' : 'community'}:
      </p>

      {communities.map((community, index) => {
        return (
          <p className="tw-mb-0 tw-text-dark-black " key={community.id}>
            &nbsp;
            {community.name}
            {index === communities.length - 1 ? '' : ', '}
          </p>
        );
      })}
    </div>
  );
};
